import $ from 'jquery';

const stickyHeaderHeight = $( '.c-header__bottom' ).outerHeight();
const searchHeaderHeight = $( '.c-site-search' ).outerHeight() - parseInt( $( '.c-site-search' ).css( "marginTop" ) );

$( '.js-toggle-tab' ).on('click', function(event) {

    var scrollTarget = $(this.hash);
    var target = $(this).attr('href');
    
    $('body').find('.c-search-filter__tab').removeClass('is-active');
    $(this).addClass('is-active');


    if (target === "#alltabs") {
        $('.c-tabs').children().addClass("is-open");
    }
    else {
        $('body').find(target).siblings().removeClass("is-open");
        $('body').find(target).addClass("is-open");
    }

    event.preventDefault();
    
    scrollTarget = scrollTarget.length ? scrollTarget : $(' [name=' + this.hash.slice(1) + '] ');
    if ( scrollTarget.length ) {
        event.preventDefault();
        $( 'html, body' ).animate({
            scrollTop: scrollTarget.offset().top - stickyHeaderHeight - searchHeaderHeight * 2
        }, 1000);
    }    
        
} );

